export type SearchPageJiraHydrationQueryVariables = {
	issueKeys: string[];
	cloudId: string;
	includeStatusCategoryId?: boolean;
};

export const jiraFieldsQueryGenerator = () => {
	return `
	query SearchPageJiraFieldHydration (
		$issueKeys: [String!]!
		$cloudId: ID!
		$includeStatusCategoryId: Boolean!
	) {
		jira {
			issuesByKey(cloudId: $cloudId, keys: $issueKeys) {
				id
				statusField {
					status {
						name
						statusCategory {
							colorName
							statusCategoryId @include(if: $includeStatusCategoryId)
						}
					}
				}
			}
		}
	}
	`;
};
